import React from 'react';
import { Sparkles } from 'lucide-react';

const CAMPO = 'mt-1 w-full h-11 px-3 rounded-lg border border-gray-300 text-sm text-gray-900 bg-white';

// Dati letti dall'AI (o da scrivere): l'utente controlla prima di salvare
export const BozzaForm = ({ b, catalogo, persone, onCambia, testid }) => {
  const f = b.form;
  const cat = catalogo.find((c) => c.codice === f.tipo);
  const set = (k, v) => onCambia({ ...f, [k]: v });
  const attuale = cat?.per_persona ? cat.persone?.find((r) => r.persona.id === f.persona_id)?.documento : cat?.documento;
  return (
    <div className="grid grid-cols-2 gap-3">
      <label className="text-xs text-gray-600 col-span-2">Documento
        <select value={f.tipo} onChange={(e) => set('tipo', e.target.value)} className={CAMPO} data-testid={`${testid}-tipo`}>
          {catalogo.map((c) => <option key={c.codice} value={c.codice}>{c.nome}</option>)}
          <option value="altro">Altro documento</option>
        </select>
      </label>
      {f.tipo === 'altro' && (
        <label className="text-xs text-gray-600 col-span-2">Nome del documento *
          <input value={f.titolo || ''} onChange={(e) => set('titolo', e.target.value)} className={CAMPO} data-testid={`${testid}-titolo`} />
        </label>
      )}
      {cat?.per_persona && (
        <label className="text-xs text-gray-600 col-span-2">Di chi è *
          <select value={f.persona_id || '__nuova'} onChange={(e) => set('persona_id', e.target.value === '__nuova' ? '' : e.target.value)}
            className={CAMPO} data-testid={`${testid}-persona`}>
            {persone.filter((p) => p.attivo).map((p) => <option key={p.id} value={p.id}>{p.nome}</option>)}
            <option value="__nuova">Altra persona (scrivi il nome)</option>
          </select>
          {!f.persona_id && (
            <input value={f.persona_nome || ''} onChange={(e) => set('persona_nome', e.target.value)} placeholder="Nome e cognome"
              className={CAMPO} data-testid={`${testid}-persona-nome`} />
          )}
        </label>
      )}
      <label className="text-xs text-gray-600">Data del documento
        <input type="date" value={f.data_documento || ''} onChange={(e) => set('data_documento', e.target.value)} className={CAMPO} data-testid={`${testid}-data`} />
      </label>
      <label className="text-xs text-gray-600">Scadenza
        <input type="date" value={f.scadenza || ''} onChange={(e) => set('scadenza', e.target.value)} className={CAMPO} data-testid={`${testid}-scadenza`} />
      </label>
      <p className="col-span-2 text-[11px] text-gray-500 -mt-1" data-testid={`${testid}-nota-scadenza`}>
        {f.scadenza_calcolata ? 'Scadenza calcolata dalla durata tipica: controllala sul documento.'
          : f.scadenza ? '' : 'Lascia vuoto se il documento non scade.'}
      </p>
      <label className="text-xs text-gray-600 col-span-2">Rilasciato da
        <input value={f.ente || ''} onChange={(e) => set('ente', e.target.value)} className={CAMPO} data-testid={`${testid}-ente`} />
      </label>
      {attuale && (
        <p className="col-span-2 rounded-lg bg-amber-50 border border-amber-200 px-2.5 py-1.5 text-[11px] text-amber-900" data-testid={`${testid}-sostituisce`}>
          {cat.con_storico ? 'C\'è già un documento: quello di prima resta nelle versioni precedenti.' : 'Sostituisce il documento attuale: quello vecchio verrà eliminato per sempre.'}
        </p>
      )}
      {b.letto && <p className="col-span-2 flex items-center gap-1 text-[11px] text-emerald-700"><Sparkles className="h-3 w-3" />Dati letti dall'AI</p>}
    </div>
  );
};
